<template>
  <div class="location-list-bd">
    <ul class="tables-head">
      <li class="ub-f2">
        <span v-if="!type">{{ $t('location_list_xmmc') }}</span>
        <span v-if="type === 'date'">{{ $t('location_list_shi_jian') }}</span>
      </li>
      <li class="ub-f1" v-if="isCoJv && showSubsidiary">
        <span>{{ $t('location_list_gong_si') }}</span>
      </li>
      <li class="ub-f2">
        <span>{{ $t('location_list_bu_men') }}</span>
      </li>
      <li class="ub-f1">
        <span>&emsp;&ensp;{{ $t('location_list_de_fen') }}</span>
      </li>
      <li class="ub-f1">
        <span>&emsp;{{ $t('location_list_shi_fou_da_biao') }}</span>
      </li>
      <li class="ub-f1">
        <span>{{ $t('location_list_qing_jie_mian_ji') }}</span>
      </li>
      <li class="ub-f1">
        <span>{{ $t('location_list_qjsc') }}</span>
      </li>
      <li class="ub-f2">
        <span>{{ $t('location_list_zhqjsj') }}</span>
      </li>
      <li class="ub-f1">
        <span>{{ $t('location_list_sbsl') }}</span>
      </li>
      <li class="ub-f1"></li>
    </ul>
    <ul class="tables-body">
      <template v-if="tableList.length > 0">
        <li class="line tb-item" v-for="(item, index) in tableList" :key="index">
          <ul class="tb-rows">
            <li class="tb-cell ub-f2 ub">
              <div>
                <i v-if="!type" class="box icon icon-xiangmu"></i>
              </div>
              <span class="bold line1" v-if="!type">{{ item.locationName }}</span>
              <span class="bold line1" v-if="type === 'date'">{{ item.reportDate }}</span>
            </li>
            <li class="tb-cell ub-f1 ub-ac" v-if="isCoJv && showSubsidiary">
              <el-tooltip :content="item.orgName" placement="top">
                <div class="line1">
                  <span ref="orgName">{{ item.orgName }}</span>
                </div>
              </el-tooltip>
            </li>
            <li class="tb-cell ub-f2 ub-ac">
              <el-tooltip :content="item.departmentName" placement="top">
                <div class="line1">
                  <span>{{ item.departmentName }}</span>
                </div>
              </el-tooltip>
            </li>
            <li class="tb-cell ub-f1 ub ub-xc">
              <div style="width: 68px; height: 68px">
                <my-pie v-if="item.goalArea" :key="`${item.reportLocationId}${item.cleanScore}`" :pie-data="item.pieChartData" :score="item.cleanScore"></my-pie>
                <span v-else>&emsp;&ensp;-</span>
              </div>
            </li>
            <li class="tb-cell ub-f1 ub">
              <div class="dit-icon" v-if="item.goalArea">
                <i class="icon icon-xinxi" style="font-size: 8px"></i>
              </div>
              <span v-if="item.goalArea" :class="{ fail: !item.isMeetGoal }">{{ item.isMeetGoal ? $t('location_list_yi_da_biao') : $t('location_list_wei_da_biao') }}</span>
              <span v-else>&emsp;&ensp;-</span>
            </li>
            <li class="tb-cell ub-f1 ubv ub-ac" v-if="item.reportLocationId">
              <div class="ub ub-sp" style="line-height: 20px">
                <span>{{ $formatLenLocal(item.totalCleanArea) || ' -' }} {{ $formatLenUnit() }}</span>
                <span>{{ item.goalArea && item.customCleanArea ? Number.parseInt((item.customCleanArea / item.goalArea) * 100) : ' -' }} %</span>
              </div>
              <div class="bar">
                <div :style="{ width: item.goalArea && item.customCleanArea ? `${(item.customCleanArea / item.goalArea > 1 ? 1 : item.customCleanArea / item.goalArea) * 100}%` : 0 }"></div>
              </div>
            </li>
            <li class="tb-cell ub-f1 ubv ub-ac" v-else>
              <div class="ub ub-sp" style="line-height: 20px">
                <span>- {{ $formatLenUnit() }}</span>
                <span>- %</span>
              </div>
              <div class="bar">
                <div :style="{ width: 0 }"></div>
              </div>
            </li>
            <li class="tb-cell ub-f1 ubv ub-ac" v-if="item.reportLocationId">
              <div class="ub ub-sp" style="line-height: 20px">
                <span>{{ Number.parseInt((item.totalUsageTime || 0) / 60, 10) | formatHourMinute }} h:m</span>
                <span>{{ item.goalTime && item.customUsageTime ? Number.parseInt((item.customUsageTime / (item.goalTime * 60)) * 100) : ' -' }} %</span>
              </div>
              <div class="bar">
                <div
                  :style="{ width: item.goalTime && item.customUsageTime ? `${(item.customUsageTime / (item.goalTime * 60) > 1 ? 1 : item.customUsageTime / (item.goalTime * 60)) * 100}%` : 0 }"
                ></div>
              </div>
            </li>
            <li class="tb-cell ub-f1 ubv ub-ac" v-else>
              <div class="ub ub-sp" style="line-height: 20px">
                <span>- min</span>
                <span>- %</span>
              </div>
              <div class="bar">
                <div :style="{ width: 0 }"></div>
              </div>
            </li>
            <li class="tb-cell ub-f2">
              <span>{{ momentAmPm($momentLocal(item.lastCleanEndTime)) }}</span>
            </li>
            <li class="tb-cell ub-f1 ub-ac">
              <el-button type="text" size="mini" @click="onDeviceNum(item)">{{ item.deviceNum }}</el-button>
            </li>
            <li class="tb-cell ub-f1 ub ub-sp ub-xc">
              <div v-if="permission.set && (permission.check ? !item.isBasicGoal : true)">
                <el-button type="text" size="mini" @click="onShowDown(item)" v-if="!item.showDown">{{ $t('location_list_szmbz') }}</el-button>
              </div>
              <div v-if="item.showDown" class="icon-box open" @click="onShowDown(item)">
                <i class="icon icon-guanbi1"></i>
              </div>
              <div v-else class="icon-box" @click="onShowDown(item)">
                <i class="icon icon-add2"></i>
              </div>
            </li>
          </ul>
          <div v-if="item.showDown" class="down-box">
            <site-list
              :list="item.siteList"
              :isSet="permission.set && (permission.check ? !item.isBasicGoal : true)"
              :selectDate="type === 'date' ? $momentWorld(item.reportDate) : selectDate"
              @success="onSuccess"
            ></site-list>
          </div>
        </li>
      </template>
      <template v-else>
        <li class="no-data">{{ $t('com_no_data') }}</li>
      </template>
    </ul>
    <device-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false"></device-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import myPie from '@/components/pie.vue';
import siteList from './site_list.vue';
import deviceDialog from './device_dialog.vue';

// location_list_xmmc: 项目名称// location_list_shi_jian: 时间// location_list_gong_si: 公司// location_list_bu_men: 部门// location_list_de_fen: 得分// location_list_shi_fou_da_biao: 是否达标// location_list_qing_jie_mian_ji: 清洁面积// location_list_qjsc: 清洁时长// location_list_zhqjsj: 最后清洁时间// location_list_sbsl: 设备数量// location_list_yi_da_biao: 已达标// location_list_wei_da_biao: 未达标// location_list_szmbz: 设置目标值

export default {
  name: 'location_list',
  components: { myPie, siteList, deviceDialog },
  props: {
    permission: {
      type: Object,
      default() {
        return { set: false, check: false };
      },
    },
    type: {
      type: String,
      default: '', // date
    },
    siteId: [String, Number],
    list: {
      type: Array,
      default() {
        return [];
      },
    },
    selectDate: [String], // 世界时间字符串
  },
  computed: {
    tableList: vm => vm.list,
  },
  watch: {
    list: function () {
      if (this.siteId && this.tableList[0]) {
        this.onShowDown(this.tableList[0]);
      }
    },
  },
  data() {
    return {
      dialogVisible: false,
      dialogModel: {},
    };
  },
  mounted: function () {
    this.mergeLanguage(null, 'portal_location_list');
    this.getFuncView();
  },
  methods: {
    onSuccess() {
      this.$emit('success');
    },
    // 展开项目
    onShowDown(item) {
      if (typeof item.showDown === 'undefined') {
        this.$set(item, 'showDown', true);
      } else {
        item.showDown = !item.showDown;
      }
      if (item.showDown && !item.siteList) {
        this.getDownList(item);
      }
    },
    // 获取项目站点
    getDownList(item) {
      this.$getJSON(apis.ProralSiteList, {
        locationId: item.locationId,
        date: this.type === 'date' ? `${item.reportDate} 00:00:00` : this.selectDate,
        // reportLocationId: item.reportLocationId,
        siteId: this.siteId,
      }).then((res) => {
        this.$set(item, 'siteList', res.data);
      });
    },
    onDeviceNum(item) {
      this.dialogModel = {
        type: 'location',
        selectDate: this.selectDate,
        row: item,
      };
      this.dialogVisible = true;
    },
  },
};
</script>

<style lang="scss">
@import '@/style/colors.scss';

.location-list-bd {
  .down-box {
    margin-top: 16px;
    border-radius: 16px;
    background-color: #ffffff;
    padding: 24px;
  }
  .tables-head {
    display: flex;
    background-color: #fff;
    border-radius: 16px;
    padding: 0 24px;
    li {
      &:first-child {
        padding-left: 0;
      }
      &:last-child {
        padding-right: 0;
      }
      height: 56px;
      line-height: 56px;
      font-size: 14px;
      padding-left: 10px;
      padding-right: 12px;
      font-weight: bold;
      color: $--color-text-secondary;
    }
  }
  .tables-body {
    height: 500px;
    overflow-y: auto;
    // 无数据
    .no-data {
      margin-top: 24px;
      height: 130px;
      text-align: center;
      line-height: 130px;
      font-size: 16px;
      color: #818181;
      background: #ffffff;
      border-radius: 16px;
    }
    .tb-item {
      .tb-rows {
        cursor: pointer;
        margin-top: 16px;
        height: 80px;
        line-height: 80px;
        border-radius: 16px;
        display: flex;
        padding: 0 24px;
        background-color: #fff;
        .tb-cell {
          &:first-child {
            padding-left: 0;
          }
          &:last-child {
            padding-right: 0;
          }
          width: 0;
          padding-left: 10px;
          padding-right: 12px;
          color: $--color-text-secondary;
          i.box {
            color: $--color-primary;
            font-size: 22px;
            margin-right: 8px;
          }
          .dit-icon {
            .icon {
              color: $--color-primary;
              font-size: 8px;
              margin-right: 10px;
            }
          }
          .icon-box {
            display: inline-block;
            border: 1.5px solid #202945;
            width: 32px;
            height: 32px;
            border-radius: 32px;
            line-height: 30px;
            text-align: center;
            color: #202945;
            &.open {
              border: none;
              line-height: 32px;
              background-color: #ffad00;
            }
            i.icon {
              font-size: 15px;
            }
          }
          .el-button span {
            color: $--color-primary;
          }
          span {
            color: $--color-text-regular;
            font-size: 14px;
            &.bold {
              font-weight: bold;
            }
            &.fail {
              color: #eb5a5a;
            }
          }
          .bar {
            height: 5px;
            border-radius: 5px;
            background: #f0f0f0;
            margin-top: 5px;
            div {
              height: 5px;
              border-radius: 5px;
              background: $--color-primary;
            }
          }
        }
      }
    }
  }
}
</style>
